import axios from "axios";
import React, { useEffect, useState } from "react";

import { format } from "../../utils";
import settings from "../../config";
import Header from "../Header";

const DashboardContent = () => {
  const [profitDetails, setProfitDetails] = useState([]);
  const [clientsRemainingBalance, setClientsRemainingBalance] = useState([]);
  const [merchantsRemainingBalance, setMerchantsRemainingBalance] = useState(
    []
  );
  const [
    accessoriesMerchantsRemainingBalance,
    setAccessoriesMerchantsRemainingBalance,
  ] = useState([]);
  const [fabricDetails, setFabricDetails] = useState([]);
  const [accessoriesDetails, setAccessoriesDetails] = useState([]);
  const [variantsDetails, setVariantsDetails] = useState([]);
  const [currentOpenCards, setCurrentOpenCards] = useState([]);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [pendingCardId, setPendingCardId] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}dashboard/profit`);

      if (response.data.statusCode === 200) {
        setProfitDetails(response.data.data);
      }

      const clientsRemainingBalanceResponse = await axios.post(
        `${settings.api}dashboard/clients`
      );

      if (response.data.statusCode === 200) {
        setClientsRemainingBalance(clientsRemainingBalanceResponse.data.data);
      }

      const merchantsRemainingBalanceResponse = await axios.post(
        `${settings.api}dashboard/merchants`
      );

      if (response.data.statusCode === 200) {
        setMerchantsRemainingBalance(
          merchantsRemainingBalanceResponse.data.data
        );
      }

      const accessoriesMerchantsRemainingBalanceResponse = await axios.post(
        `${settings.api}dashboard/accessories-merchants`
      );

      if (response.data.statusCode === 200) {
        setAccessoriesMerchantsRemainingBalance(
          accessoriesMerchantsRemainingBalanceResponse.data.data
        );
      }

      const fabricDetailsResponse = await axios.post(
        `${settings.api}dashboard/fabric-details`
      );

      if (response.data.statusCode === 200) {
        setFabricDetails(fabricDetailsResponse.data.data);
      }

      const accessoriesDetailsResponse = await axios.post(
        `${settings.api}dashboard/accessories-details`
      );

      if (response.data.statusCode === 200) {
        setAccessoriesDetails(accessoriesDetailsResponse.data.data);
      }

      const variantsDetailsResponse = await axios.post(
        `${settings.api}dashboard/variants-details`
      );

      if (response.data.statusCode === 200) {
        setVariantsDetails(variantsDetailsResponse.data.data);
      }
    })();
  }, []);

  // Reset authentication when component unmounts (user navigates away)
  useEffect(() => {
    return () => {
      setIsAuthenticated(false);
    };
  }, []);

  const handleCardClick = (cardId) => {
    if (isAuthenticated) {
      // If already authenticated, directly toggle the card
      toggleCard(cardId);
    } else {
      // If not authenticated, show password modal
      setPendingCardId(cardId);
      setShowPasswordModal(true);
      setPassword("");
      setPasswordError("");
    }
  };

  const toggleCard = (cardId) => {
    if (currentOpenCards.indexOf(cardId) === -1) {
      setCurrentOpenCards([...currentOpenCards, cardId]);
    } else {
      setCurrentOpenCards([
        ...currentOpenCards.filter((card) => card !== cardId),
      ]);
    }
  };

  const handlePasswordSubmit = () => {
    // You can change this password as needed
    const correctPassword = "1234";

    if (password === correctPassword) {
      // Set authentication status
      setIsAuthenticated(true);

      // Toggle the pending card
      toggleCard(pendingCardId);

      // Close modal and reset
      setShowPasswordModal(false);
      setPendingCardId(null);
      setPassword("");
      setPasswordError("");
    } else {
      setPasswordError("كلمة المرور غير صحيحة");
    }
  };

  const handleModalClose = () => {
    setShowPasswordModal(false);
    setPendingCardId(null);
    setPassword("");
    setPasswordError("");
  };

  return (
    <div dir="ltr">
      <Header title="الرئيسيه" />
      <div className="flex gap-x-8 gap-y-8 flex-wrap justify-center flex-row-reverse">
        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(1)}
        >
          <div className="text-center">الربح</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(1) === -1 ? "blur-md" : ""
            }`}
          >
            {format(profitDetails[0]?.profit)}
          </div>
        </div>
        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(2)}
        >
          <div className="text-center">المتبقى علي العملاء</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(2) === -1 ? "blur-md" : ""
            }`}
          >
            {format(clientsRemainingBalance[0]?.balance)}
          </div>
        </div>
        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(3)}
        >
          <div className="text-center">المتبقى من تجار القماش</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(3) === -1 ? "blur-md" : ""
            }`}
          >
            {format(merchantsRemainingBalance[0]?.balance)}
          </div>
        </div>
        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(4)}
        >
          <div className="text-center">المتبقى من تجار الاكسسوارات</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(4) === -1 ? "blur-md" : ""
            }`}
          >
            {format(accessoriesMerchantsRemainingBalance[0]?.balance)}
          </div>
        </div>

        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(5)}
        >
          <div className="text-center">سعر القماش المتبقى</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(5) === -1 ? "blur-md" : ""
            }`}
          >
            {format(fabricDetails[0]?.totalPrice)}
          </div>
        </div>

        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(6)}
        >
          <div className="text-center">سعر الاكسسوارات المتبقى</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(6) === -1 ? "blur-md" : ""
            }`}
          >
            {format(accessoriesDetails[0]?.totalPrice)}
          </div>
        </div>

        <div
          className="cursor-pointer w-full lg:w-60  hover:bg-textPrimary/10 p-10 bg-gradient-to-b from-secondaryBg rounded-lg"
          onClick={() => handleCardClick(7)}
        >
          <div className="text-center">سعر الاصناف المتبقى</div>
          <div
            className={`text-xl text-center ${
              currentOpenCards.indexOf(7) === -1 ? "blur-md" : ""
            }`}
          >
            {format(variantsDetails[0]?.totalPrice)}
          </div>
        </div>
      </div>

      {/* Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999]">
          <div className="bg-secondaryBg p-8 rounded-lg shadow-lg w-1/4 min-w-80">
            <h2 className="text-xl font-bold text-center mb-6 text-primaryText">
              ادخل كلمة المرور
            </h2>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handlePasswordSubmit()}
              placeholder="كلمة المرور"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-center text-lg mb-4"
              autoFocus
            />
            {passwordError && (
              <p className="text-red-500 text-center mb-4">{passwordError}</p>
            )}
            <div className="flex gap-4">
              <button
                onClick={handleModalClose}
                className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-lg hover:bg-gray-600 transition-colors font-medium p-2"
              >
                إلغاء
              </button>
              <button
                onClick={handlePasswordSubmit}
                className="flex-1 bg-blue-500 text-white py-3 px-6 rounded-lg hover:bg-blue-600 transition-colors font-medium p-2"
              >
                تأكيد
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardContent;
